<template>
  <v-menu v-model="menu" offset-x :close-on-content-click="false">
    <template #activator="{ on, attrs }">
      <v-btn v-on="on" v-bind="attrs" icon>
        <v-icon>mdi-help-circle-outline</v-icon>
      </v-btn>
    </template>

    <v-card
      :style="{
        minWidth: '600px',
        maxWidth: '900px',
      }"
    >
      <v-card-title>
        {{ title }}
        <v-spacer></v-spacer>
        <v-btn @click="menu = false" icon>
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text style="max-height: 70dvh; overflow-y: auto">
        <div v-if="text" v-html="text" class="mb-5"></div>

        <div v-for="group in glossary" :key="group.name" class="mb-4">
          <div class="subtitle-2 mb-2 pl-4" v-text="group.name"></div>
          <v-simple-table dense>
            <tbody>
              <tr v-for="line in group.lines" :key="line.variable">
                <td width="200">
                  <v-chip
                    @click="handleClickLine(line)"
                    small
                    label
                    link
                    color="#e5eeed"
                    class="primary--text"
                  >
                    {{ line.variable }}
                    <v-icon x-small right color="primary">
                      mdi-content-copy
                    </v-icon>
                  </v-chip>
                </td>
                <td class="caption">
                  {{ line.description || "---" }}
                </td>
              </tr>
            </tbody>
          </v-simple-table>
        </div>
      </v-card-text>
    </v-card>
  </v-menu>
</template>

<script>
import ToastsMixin from "@/mixins/ToastsMixin.vue";

export default {
  mixins: [ToastsMixin],

  components: {},

  props: {
    title: String,
    text: String,
    glossary: Array,
  },

  data() {
    return {
      menu: false,
    };
  },

  methods: {
    handleClickLine(line) {
      navigator.clipboard.writeText(`\${${line.variable}}`);
      this.toast("Copiado");
    },
  },

  computed: {},
};
</script>
